import { BaseApiService } from '@/services/base-service';
import { FiltersPagination, Response, BaseResponse } from '@/types';
import {
  Characteristic,
  Products,
  ProductsFilters,
  ProductsList,
  ModelsList,
  CatalogRequestFilters,
  CatalogRequest,
} from '../types';
import CatalogResponse = Products.CatalogResponse;

export class ProductsService extends BaseApiService {
  private readonly base_path = 'products';

  async get_products(payload: FiltersPagination<ProductsFilters>): Promise<ProductsList> {
    const payload_filters = payload.filters;

    payload_filters.search = payload_filters.search ? payload_filters.search : '';

    const { data } = await this.http_client.get<ProductsList>(this.base_path, {
      params: {
        filters: payload_filters,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_catalog(payload: CatalogRequest): Promise<CatalogResponse> {
    const payload_filters = payload.filters;

    payload_filters.search = payload_filters.search ? payload_filters.search : '';

    const { data } = await this.http_client.get<CatalogResponse>('catalog', {
      params: {
        filters: payload_filters,
        filters_exist: payload.filters_exist,
        limit: payload.pagination.limit,
        page: payload.pagination.page,
        sort: payload.pagination.sort,
        sort_type: payload.pagination.sort_type,
      },
    });

    return data;
  }

  async get_product_by_id(id: number): Promise<Response<Products.Product>> {
    const { data } = await this.http_client.get<Response<Products.Product>>(`${this.base_path}/${id}`);

    return data;
  }

  async get_equipment_model(params: any): Promise<ModelsList> {
    const url = `${this.base_path}/cash_registers`;

    const { data } = await this.http_client.get<ModelsList>(url, { params });

    return data;
  }

  async get_prod_characteristics(id: string): Promise<Response<Characteristic[]>> {
    const { data } = await this.http_client.get<Response<Characteristic[]>>(`${this.base_path}/${id}/characteristics`);

    return data;
  }

  async search_products(search: string): Promise<ProductsList> {
    const { data } = await this.http_client.get<ProductsList>(this.base_path, { params: { filters: { search } } });

    return data;
  }

  async get_prices_types(): Promise<Response<string[]>> {
    const { data } = await this.http_client.get<Response<string[]>>(`${this.base_path}/prices_types`);

    return data;
  }

  async get_license_keys(id: number, search?: string): Promise<any> {
    const { data } = await this.http_client.get<Response<any>>(`${this.base_path}/${id}/license_keys`, {
      params: { search },
    });

    return data;
  }

  async add_to_favorites(id: number): Promise<Response<BaseResponse>> {
    const { data } = await this.http_client.post<Response<BaseResponse>>(`${this.base_path}/${id}/favorite`);

    return data;
  }

  async remove_from_favorites(id: number): Promise<Response<BaseResponse>> {
    const { data } = await this.http_client.delete<Response<BaseResponse>>(`${this.base_path}/${id}/favorite`);

    return data;
  }
}

export const default_filters = (): ProductsFilters => ({
  search: '',
  in_stock: false,
  category: [],
  software_type: '',
  select_type: 'active',
  models: [],
  display_warehouse_id: null,
  is_favorite_only: false,
  is_allowed_by_realization: false,
});

export const default_catalog_filters = (): CatalogRequestFilters => ({
  search: '',
  in_stock: false,
  categories: [],
  software_type: null,
  equipment_models: [],
  is_favorite_only: false,
  is_allowed_by_realization: false,
});
